import React from 'react';

const BCIndustryActivityFormModal = React.lazy(() => import('../components/FormModal'));
const bCIndustryActivityModalRegistry = {
    company_bcIndustryActivityId: BCIndustryActivityFormModal
};
export default bCIndustryActivityModalRegistry;
